import Main from '@/components/Layout/Layout'
import SubMain from '@/views/Main'

export default {
  sort: 1,
  routers: [
    {
      path: '/Action',
      name: 'action',
      component: Main,
      meta: {
        isHideInMenu: false,
        isCache: false,
        icon: 'alert',
        title: '行为'
      },
      redirect: '/Action/Merchant/Action',
      children: [
        {
          path: '/Action/Merchant',
          name: '',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'solution',
            title: '商户行为日志'
          },
          redirect: '/Action/Merchant/Action',
          children: [
            {
              path: '/Action/Merchant/Action',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '用户操作日志'
              },
              component: () => import('@/views/Action/Merchant/UserAction')
            }
          ]
        },
        {
          path: '/Action/Internal',
          name: 'form',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'border-inner',
            title: '内部行为日志'
          },
          redirect: '/Action/Internal/UserAction',
          children: [
            {
              path: '/Action/Internal/UserAction',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: '',
                title: '用户操作日志'
              },
              component: () => import('@/views/Action/Internal/UserAction.vue')
            }
          ]
        },
        // {
        //   path: '/Action/System',
        //   name: 'form',
        //   component: SubMain,
        //   meta: {
        //     isHideInMenu: false,
        //     isCache: false,
        //     icon: 'database',
        //     title: '系统行为日志'
        //   },
        //   redirect: '/Action/System/ChannelNotification',
        //   children: [
        //     {
        //       path: '/Action/System/ChannelNotification',
        //       name: '',
        //       meta: {
        //         isHideInMenu: false,
        //         isCache: false,
        //         icon: '',
        //         title: '渠道日志'
        //       },
        //       component: () => import('@/views/Action/System/ChannelNotification.vue')
        //     }
        //   ]
        // },
        {
          path: '/Action/Notification',
          name: 'form',
          component: SubMain,
          meta: {
            isHideInMenu: false,
            isCache: false,
            icon: 'notification',
            title: '消息通知日志'
          },
          redirect: '/Action/Notification/DingDing',
          children: [
            // {
            //   path: '/Action/Notification/DingDing',
            //   name: '',
            //   meta: {
            //     isHideInMenu: false,
            //     isCache: false,
            //     icon: 'dingding',
            //     title: '钉钉通知'
            //   },
            //   component: () => import('@/views/Action/Notification/DingDing.vue')
            // },
            {
              path: '/Action/Notification/Mail',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: 'mail',
                title: '邮件通知'
              },
              component: () => import('@/views/Action/Notification/Mail.vue')
            },
            {
              path: '/Action/Notification/Message',
              name: '',
              meta: {
                isHideInMenu: false,
                isCache: false,
                icon: 'message',
                title: '短信通知'
              },
              component: () => import('@/views/Action/Notification/Message.vue')
            }
          ]
        }
      ]
    }
  ]
}
